/* eslint-disable no-console */
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './root-saga';
import createReducerManager from './reducer-manager';
import createSagaInjector from './saga-manager';
import SliceManager from './slice-manager';

export default (initialState, initialReducers) => {
  const reducerManager = createReducerManager(initialReducers);

  const sagaMiddleware = createSagaMiddleware({
    onError: (error) => {
      console.info('Saga Root Destroyed');
      console.error(error);
    },
  });

  const store = configureStore({
    reducer: reducerManager.getCombinedReducers(),
    middleware: (getDefaultMiddleware) => (
      [
        ...getDefaultMiddleware({ thunk: false }),
        sagaMiddleware,
      ]
    ),
    devTools: process.env.NODE_ENV !== 'production',
  });

  store.asyncReducers = {};

  // This function adds the async reducer, and creates a new combined reducer
  store.injectReducer = (key, asyncReducer, initialData) => {
    if (reducerManager.removable(key)) {
      console.log(`Found existing reducer ${key}`);
      return;
    }

    // Inject new reducer
    reducerManager.add(key, asyncReducer, initialData);
    store.replaceReducer(reducerManager.getCombinedReducers());
  };

  store.removeReducer = (key) => {
    if (reducerManager.removable(key)) {
      reducerManager.remove(key);
      // delete store.getState()[key];
      store.replaceReducer(reducerManager.getCombinedReducers());
    }
  };

  store.injectSaga = createSagaInjector(sagaMiddleware.run, rootSaga);

  store.hasReducer = createReducerManager.has;

  SliceManager.init(store);

  store.injectSlice = SliceManager.injectSlice;

  store.hasSlice = SliceManager.hasSlice;

  return store;
};
